"use strict";

Shopify.theme.jsAsSeenOn = {

  init: function init($section) {
    this.createSlider();
  },
  createSlider: function createSlider() {
    
    var $asSeenOnSlider = $('.as-seen-on-holder').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      slide: '.as-seen-on-block',
      nextArrow: $('.aso-next-arrow'),
      fade: false,
      //infinite: false,
      infinite: true,
      focusOnSelect: true,
      //centerMode: true,
      centerMode: false,
      rows: 0

      ,responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    });

  },
  blockSelect: function blockSelect($section, blockId) {
    var $asSeenOnSlider = $section.find('.as-seen-on-holder');
    var slideIndex = $('#as-seen-on-section-' + blockId).data('item-index');
    $asSeenOnSlider.slick('slickGoTo', slideIndex, true, true);
  },
  unload: function unload($section) {

    var $slider = $section.find('.as-seen-on-holder');
    $slider.slick('unslick');
  }
};



document.addEventListener("shopify:section:load", function(event) {
  Shopify.theme.jsAsSeenOn.init();
});



window.addEventListener('load', function () {
  Shopify.theme.jsAsSeenOn.init();
}, false);




